import ReactApexChart from "react-apexcharts";
import { Card, CardBody, Col } from "reactstrap";
import { SalesStatsTitle } from "../../../../constants";
import { SalesStatsOption } from "../../../../data/general/dashboard/Default";
import { CustomerGrowthProp } from "../../../../types/General";
import DashboardHeader from "../common/DashboardHeader";

const SalesStats: React.FC<CustomerGrowthProp> = ({ colClass }) => {
  return (
    <Col className={colClass}>
      <Card>
        <DashboardHeader title={SalesStatsTitle} headerClass="custom-border-bottom" dropdownToggleClass="dropdown-toggle" dropdownClass="setting-menu" />
        <CardBody className="pt-0">
          <div id="salesStatsRadialChart">
            <ReactApexChart options={SalesStatsOption} series={SalesStatsOption.series} type="radialBar" height={360} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default SalesStats;
